import { render } from "./ErrorsList.vue?vue&type=template&id=65481c14&scoped=true"
import script from "./ErrorsList.vue?vue&type=script&lang=js"
export * from "./ErrorsList.vue?vue&type=script&lang=js"

import "./ErrorsList.vue?vue&type=style&index=0&id=65481c14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65481c14"]])

export default __exports__